import { UnitRead } from "@types";

export const useGetUnits = () => {
  const columns = [
    { field: "location.locationName", header: "Location Name" },
    { field: "name", header: "Name" },
    { field: "type", header: "Type" },
    { field: "status", header: "Status" },
    { field: "condition", header: "Condition" },
    { field: "initialPrice", header: "Initial Price" },
    { field: "salePrice", header: "Sale Price" },

    {
      header: "Unit Size",
      body: (rowData: UnitRead) => {
        const size = rowData.size?.description;

        return (
          <span className={size ? "text-color" : "text-400 italic"}>
            {size || "No size assigned"}
          </span>
        );
      },
    },
  ];

  return { columns };
};
